import { render, staticRenderFns } from "./StockCostCompare.vue?vue&type=template&id=cd052582&scoped=true"
import script from "./StockCostCompare.vue?vue&type=script&lang=js"
export * from "./StockCostCompare.vue?vue&type=script&lang=js"
import style0 from "./StockCostCompare.vue?vue&type=style&index=0&id=cd052582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd052582",
  null
  
)

export default component.exports